<template>
  <Modal
    width="496"
    v-model.trim="cForm.modal"
    :title="cForm.id ? '编辑' : '新增'"
    :loading="cForm.loading"
    @on-ok="submit"
  >
    <Form
      class="c-form c-form--modal"
      ref="form"
      :model="cForm.model"
      :rules="cForm.rules"
      :label-width="80"
    >
      <Form-item label="姓名" prop="name">
        <Input
          class="c-form__input"
          v-model.trim="cForm.model.name"
          placeholder="请输入姓名"
        />
      </Form-item>
      <Form-item label="绑定微信" prop="wxUserId">
        <c-school-wx-user-select
          class="c-form__input"
          :key="cForm.model.id"
          :school-id="getSchoolId()"
          :value="cForm.model.wxUserId"
          @change="
            value => {
              $set(cForm.model, 'wxUserId', value);
            }
          "
        >
        </c-school-wx-user-select>
      </Form-item>
      <Form-item label="手机号" prop="phoneNumber">
        <Input
          class="c-form__input"
          maxlength="11"
          v-model.trim="cForm.model.phoneNumber"
          placeholder="请输入手机号"
        />
      </Form-item>
      <Form-item label="是否校长" prop="isadmin">
        <Select class="c-form__input" v-model="cForm.model.isadmin">
          <Option
            v-for="item in dicts.EnableStatus"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          >
            {{ item.label }}
          </Option>
        </Select>
      </Form-item>
      <Form-item label="发布权限" prop="fbstatus">
        <Select class="c-form__input" v-model="cForm.model.fbstatus">
          <Option
            v-for="item in dicts.EnableStatus"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          >
            {{ item.label }}
          </Option>
        </Select>
      </Form-item>
      <Form-item label="介绍" prop="introduction">
        <Input
          class="c-form__input"
          type="textarea"
          :rows="5"
          v-model="cForm.model.introduction"
          placeholder="请输入介绍"
        />
      </Form-item>
    </Form>
  </Modal>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import FormMixin from "view-ui-admin/src/mixins/form";

const module = "teachers";

@Component({
  mixins: [FormMixin]
})
export default class ListForm extends Vue {
  data() {
    return {
      cForm: {
        id: 0,
        modal: false,
        loading: true,
        model: this.getFormInitModel(),
        rules: {
          name: [
            {
              required: true,
              message: "姓名不能为空"
            }
          ],
          phoneNumber: [
            {
              pattern: /^1\d{2}\s?\d{4}\s?\d{4}$/,
              message: "手机号格式错误"
            }
          ]
        }
      }
    };
  }

  getFormInitModel() {
    return {};
  }

  show(detail) {
    this.cForm.modal = true;

    if (detail && detail.id) {
      this.cForm.id = detail.id;
      this.initFormFields(detail);
    } else {
      this.cForm.id = 0;
    }
  }

  submit() {
    this.$refs.form.validate(async valid => {
      if (valid) {
        const { id, model } = this.cForm;
        const { data } = await this.$store.dispatch(
          `${module}/${id ? "put" : "post"}`,
          {
            id,
            body: model
          }
        );

        this.cForm.modal = false;
        this.$Message.success(`${id ? "编辑" : "新增"}成功`);
        this.$emit("get-list", data);
      }

      this.fixFormButtonLoading();
    });
  }
}
</script>
